export default __webpack_public_path__ + "static/media/daisies.187d54fb.jpg";